Namespace 'Common.Sessions'

class Common.Sessions.ListView extends Backbone.View
  template: JST['backbone/templates/common/sessions/session_list']

  events:
    'input #session-search': 'searchSessions'
    'click .remove_all_session': 'removeAllSessions'

  initialize: ({sessions}) ->
    @sessions = sessions
    @listenTo(@sessions, 'update', @render)
    @listenTo(@sessions, 'change', @render)

  render: ->
    @$el.html @template
      hasSessions: @sessions.length
    @_renderSessionListItems()
    @

  _renderSessionListItems: =>
    $list = @$('.session-list-items')
    $list.append $('<div></div>')
    @sessions.getSavedSessions().forEach (session) =>
      $list.append(@_sessionListItemHTML(session))

  _sessionListItemHTML: (session) ->
    new Common.Sessions.SessionListItemView(session: session, sessions: @sessions).render().el

  searchSessions: (event) =>
    inputValue = $(event.target).get(0).value
    sessions = @$el.find('.saved-session')
    $(session).toggle(@_sessionNameMatches(session, inputValue)) for session in sessions

  removeAllSessions: =>
    swal
      title: I18n.t 'monitoring.dashboard.session.modal_delete_all'
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t 'monitoring.dashboard.session.s_yes'
      cancelButtonText: I18n.t 'monitoring.dashboard.session.s_cancel'
      closeOnConfirm: true
      customClass: 'common'
      => @sessions.destroyAll()

  _sessionNameMatches: (session, text) ->
    @_sessionName(session).toUpperCase().indexOf(text.toUpperCase()) != -1

  _sessionName: (session) ->
    $(session).find('.name').text().trim()
